const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const DateFilterAhead = require('components/commons/dateFilter/dateFilterAhead');
const OKModal = require('components/commons/OKModal/OKModal');
// @ constants
const { DATE_FILTER_NONE } = require('constants/index');
//@utilities
const { recordLinkV2 } = require('utilities/tagging');
const { commonFilterAnalyticsId, commonCatalogueFilters } = require('utilities/taggingCommonCatalogue');

class LoanFilter extends React.Component {
    constructor(props) {
        super(props);

        const { immFilter } = props;
        const immDate = immFilter.get('date');

        this.state = {
            dateSelected: immDate.get('selected'),
            dateFrom: immDate.get('from'),
            dateTo: immDate.get('to')
        };

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleChangeDateMin = this.handleChangeDateMin.bind(this);
        this.handleChangeDateMax = this.handleChangeDateMax.bind(this);
        this.handleChangeDateSelected = this.handleChangeDateSelected.bind(this);
        this.handleCancelModal = this.handleCancelModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.onTaggingToDate = this.onTaggingToDate.bind(this);
        this.onTaggingFromDate = this.onTaggingFromDate.bind(this);
    }
    componentDidMount() {
        recordLinkV2(commonCatalogueFilters[commonFilterAnalyticsId.OPEN_MODAL]());
    }

    handleChangeDateMax(dateTo) {
        this.setState({
            dateTo
        });
    }

    handleChangeDateMin(dateFrom) {
        this.setState({
            dateFrom
        });
    }

    handleChangeDateSelected(dateSelected) {
        this.setState({
            dateSelected
        });
    recordLinkV2(commonCatalogueFilters[commonFilterAnalyticsId.SELECT_DATE](dateSelected));
    }

    handleFormSubmit(event) {
        event.preventDefault();
        recordLinkV2(commonCatalogueFilters[commonFilterAnalyticsId.APPLY_BUTTON]());
        const { onSetFilters, onCloseClick } = this.props;
        const { dateFrom, dateTo, dateSelected } = this.state;

        onSetFilters({
            date: {
                selected: dateSelected,
                from: dateFrom,
                to: dateTo
            },
            isActive : dateSelected !== DATE_FILTER_NONE && !!dateFrom && !!dateTo
        });

        onCloseClick();
    }

    handleCancelModal() {
        const { onCloseClick } = this.props;
        recordLinkV2(commonCatalogueFilters[commonFilterAnalyticsId.CANCEL_BUTTON]());
        onCloseClick();
    }

    handleCloseModal() {
        const { onCloseClick } = this.props;
        recordLinkV2(commonCatalogueFilters[commonFilterAnalyticsId.CLOSE_MODAL]());
        onCloseClick();
    }

    onTaggingToDate() {
        recordLinkV2(commonCatalogueFilters[commonFilterAnalyticsId.INPUT_TO]());
    }

    onTaggingFromDate() {
        recordLinkV2(commonCatalogueFilters[commonFilterAnalyticsId.INPUT_FROM]());
    }

    render() {
        const { immFilter } = this.props;
        const modalContent = (
            <article className="loan-repayment-plan-filters">
                <section>
                    <form onSubmit={this.handleFormSubmit}>
                        <fieldset>
                            <DateFilterAhead
                                immFilter={immFilter.get('date')}
                                handleTaggingToDate={this.onTaggingToDate}
                                handleTaggingFromDate={this.onTaggingFromDate}
                                onChangeMin={this.handleChangeDateMin}
                                onChangeMax={this.handleChangeDateMax}
                                onChangeSelected={this.handleChangeDateSelected}
                                showAnnual={false}
                                showBiannual={false}
                                showFortnightly={false}
                                showMonthly={false}
                            />
                        </fieldset>
                    </form>
                </section>
            </article>
        );

        return (
            <OKModal
                content={modalContent}
                footerType="navigation"
                isOpen={true}
                onCloseCallback={this.handleCloseModal}
                onPrimaryButtonClick={this.handleFormSubmit}
                onSecondaryButtonClick={this.handleCancelModal}
                primaryButtonText="common-apply"
                secondaryButtonText="common-cancel"
                title="loanRepaymentPlanFilter-title"
                type="filter"
            />
        );
    }
}

LoanFilter.propTypes = {
    immFilter: PropTypes.object.isRequired,
    onSetFilters: PropTypes.func.isRequired,
    onCloseClick: PropTypes.func.isRequired
};

module.exports = LoanFilter;
